module.exports = __webpack_public_path__ + "img/icons8-facebook-f.c658fa86.svg";